import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../UploadImageComponent";
import imgConfirmDelete from "../../assets/image-confirm-delete.png";
export default function PopUpConfirmDelete({
  open,
  onClose,
  onSubmit,
  title,
  sub,
}) {
  // state
 

  // useEffect

  return (
    <Modal show={open} onHide={onClose} size="sm">
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
          paddingBottom: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#343A40", fontSize: 20, fontWeight: 700 }}>
            {title}
          </h1>
          <p style={{ color: "#6C757D", fontSize: 16 }}>{sub}</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={imgConfirmDelete} alt="" style={{ width: 100 }} />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 20 }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <Button
            variant="outline-primary"
            size="md"
            style={{ minWidth: 120 }}
            onClick={onClose}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="danger"
            size="md"
            style={{ minWidth: 120 }}
            onClick={onSubmit}
         
          >
            ຢືນຢັນ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
